export default __webpack_public_path__ + "static/media/downloads.9ab4c690.svg";